import { render, staticRenderFns } from "./supplier-contracts-list.vue?vue&type=template&id=0d66ae0c&scoped=true"
import script from "./supplier-contracts-list.vue?vue&type=script&lang=js"
export * from "./supplier-contracts-list.vue?vue&type=script&lang=js"
import style0 from "./supplier-contracts-list.vue?vue&type=style&index=0&id=0d66ae0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d66ae0c",
  null
  
)

export default component.exports